<template>
	<div class="addons-page">
		<!-- <b-card> -->
			<b-row>
				<b-col sm="5">
					<div class="account-label">Your infinitewp.com account:</div><div v-if="plan.appRegisteredUser" class="register-user">{{plan.appRegisteredUser}}</div> <div v-if="!plan.appRegisteredUser" class="register-user">You have not connected your account <b-btn variant="link" size="sm" @click="showLoginModal('register')">Connect now</b-btn></div>
					<b-modal ref="userLogin" modal-class="addons-page"  hide-footer centered hide-header-close no-close-on-esc no-close-on-backdrop title="Login" no-fade>
				        <div class="login-error aler-msg" v-if="loginError"><span class="error_svg"><error-icon class="icon-default"></error-icon></span><div class="error_msss" v-html="loginError"></div></div>
				        <b-form @submit="userLogin">
							<div class="login-form">
						        <b-form-group id="userName" label="Login to infinitewp.com" label-for="user_name">
						          <b-form-input id="user_name"  :class="{ 'invalid': $v.login.username.$error }" type="text" placeholder="username" v-model="login.username" >
						          </b-form-input>
						        </b-form-group>
						        <b-form-group id="password" label-for="user_name">
						          <b-form-input id="password" :class="{ 'invalid': $v.login.username.$error }" type="password" placeholder="password" autocomplete="" v-model="login.password" >
						          </b-form-input>
						          <small id="password__BV_description_" class="form-text text-muted">Forgot username or password? <a :href="appInfo.IWP_SITE_URL" target="blank">Reset</a></small>
						        </b-form-group>
							</div>
							<div class="login-footer">
					       		<b-btn variant="flat" size="sm" @click="hideLoginModal()">Cancel</b-btn>
					       		<b-btn  type="submit" variant="primary" size="sm"  :disabled="buttonLoaders.login" >Login
								<spinner size="small" v-if="buttonLoaders.login"></spinner>
					       		</b-btn>
							</div>
						</b-form>
				    </b-modal>
					<div class="plan-details" v-if="plan.appRegisteredUser && plan.activeTierPlan">
						<b-row>
							<b-col class="left-label">Current Plan</b-col>
							<b-col class="right-label acitve-plan">{{plan.activeTierPlan}}</b-col>
						</b-row>
						<b-row>
							<b-col class="left-label">Site Limit</b-col>
							<b-col class="right-label">{{plan.activePlanSiteLimit}}</b-col>
						</b-row>
						<b-row>
							<b-col class="left-label">Valid Till</b-col>
							<b-col class="right-label">{{plan.validTill}}</b-col>
						</b-row>
						<b-row>
							<b-col class="left-label">Addons</b-col>
							<b-col class="right-label" v-if="!plan.isAddonPlanExpired">All - {{plan.addonCounts}} addons</b-col>
							<b-col class="right-label" v-if="plan.isAddonPlanExpired"><error-icon class="icon-expire"></error-icon><span class="expired">Expierd</span> (Note: no longer receive any updates)
							<b-btn variant="primary" v-if="plan.isAddonPlanExpired" size="sm" :href="appInfo.IWP_SITE_URL" style="margin-top: 7px;">Active Now</b-btn>
							</b-col>
						</b-row>
						<b-row>
							<b-col class="left-label">Email Support</b-col>
							<b-col class="right-label">{{plan.emailSupport}}</b-col>
						</b-row>
					</div>
					<hr>
				</b-col>
				<b-col>
					<div class="install-addons-header"><span>Your Purchased Addons</span>
						<b-btn variant="primary" size="sm" :disabled="!plan.newAddons" @click="showLoginModal('installAddons')">Install All Addons</b-btn>
					</div>
					<div class="addon-table" v-if="plan.newAddons">
						<table width="100%" >
							<tr class="install-addons-list">
								<td v-if="plan.appRegisteredUser"><b-btn variant="outline-secondary" size="sm" :disabled="buttonLoaders.checkUpdate" @click="checkUpdate()"><reload-icon class="icon-default checknow"></reload-icon>Check now<spinner size="small" v-if="buttonLoaders.checkUpdate"></spinner></b-btn></td>
								<td v-if="!plan.appRegisteredUser"><b-btn variant="outline-secondary" size="sm" :disabled="buttonLoaders.checkUpdate" @click="showLoginModal('register')"><reload-icon class="icon-default checknow"></reload-icon>Check now<spinner size="small" v-if="buttonLoaders.checkUpdate"></spinner></b-btn></td>
							</tr>
							<tr class="install-addons-list" v-for=" addon in plan.newAddons" :key="addon.slug">
									<td class="addon-name"><span>{{addon.addon}}</span><span class="version"> v{{addon.version}}</span></td>
							</tr>
						</table>
					</div>
					<div class="addon-empty" v-if="!plan.newAddons">
						<b-btn variant="outline-secondary" size="sm" :disabled="buttonLoaders.checkUpdate" v-if="plan.appRegisteredUser" @click="checkUpdate()">
							<reload-icon class="icon-default checknow"></reload-icon>Check now<spinner size="small" v-if="buttonLoaders.checkUpdate"></spinner>
						</b-btn>
						<b-btn variant="outline-secondary" size="sm" :disabled="buttonLoaders.checkUpdate" v-if="!plan.appRegisteredUser" @click="showLoginModal('register')">
							<reload-icon class="icon-default checknow"></reload-icon>Check now<spinner size="small" v-if="buttonLoaders.checkUpdate"></spinner>
						</b-btn>
						<div><br>You have installed all purchased addons / You have not purchased any new addons. You can purchase addons from the <a :href="appInfo.IWP_SITE_URL">InfiniteWP addon store.</a></div>
					</div>
					<br>
					<div class="install-addons-header">Installed Addons</div>
					<div class="addon-table" v-if="plan.installedAddons">
						<table width="100%" >
							<tr class="install-addons-content header">
									<td class="addon-name">Addons</td>
									<td>Valid Till</td>
									<td>Active/Inactive</td>
							</tr>
							<tr class="install-addons-list" v-for=" addon in plan.installedAddons" :key="addon.slug">
									<td v-bind:class="{opacity:addon.status=='inactive'}" width="50%">
										<component :is="addon.slug" class="addons-icon"></component><span>{{addon.addon}}</span><span class="version"> v{{addon.version}}</span>
									</td>
									<td v-bind:class="{opacity:addon.status=='inactive', expired:addon.isValidityExpired}">{{addon.validTillAddon}}</td>
									<td><div @click="activeORdeactivae(addon.slug, addon.status)">
										<switches v-model="addon.status == 'active'"  theme="bootstrap" color="primary" v-b-tooltip.hover :title="addon.status"></switches>
										<a :href="appInfo.IWP_SITE_URL" v-if="addon.isValidityExpired" class="renew-link">Renew</a>
										<!-- <a :href="appInfo.IWP_SITE_URL" class="renew-link" v-if="addon.isValidityExpired">Renew</a> -->
										</div>
									</td>
							</tr>
						</table>
					</div>
					<div class="addon-empty" v-if="!plan.installedAddons">You have not installed any addons yet.</div>
					<br>
					<div class="install-addons-header" v-if="plan.updateAvailableAddons && !plan.isAddonPlanExpired"><span>Update available Addons</span>
						<b-btn variant="primary" size="sm" :disabled="!plan.updateAvailableAddons" @click="showUpdateModal()">Update All Addons</b-btn>
					</div>
					<div class="addon-table" v-if="plan.updateAvailableAddons && !plan.isAddonPlanExpired">
						<table width="100%" >
							<tr class="install-addons-list" v-for=" addon in plan.updateAvailableAddons" :key="addon.slug">
									<td class="addon-name update-addon" v-if="addon.updateAvailable">
										<span>{{addon.addon}}</span>
										<span class="version"> 
											<a :href="addon.updateAvailable.changeLogLink" target="blank"> v{{addon.updateAvailable.version}}</a>
										</span>
										<span class=" version float-right" @click="singleAddonUpdate(addon.slug)" ><a>Update</a></span>
									</td>
							</tr>
						</table>
					</div>

					<div id="install-modal">
						<b-modal modal-class="addons-page install-modal" ref="addonInstallAndUpdateModel" hide-footer centered no-close-on-esc hide-header no-close-on-backdrop no-fade>
							<div class="model-title">{{addonModalTitle}} Addon(s)..</div>
							<div v-if="!installError && !installFinished">
								<div class="progress-msg">{{progressMsg}}...</div>
								<b-progress :value="value" :max="max" class="install-progress" height="6px" striped :animated="true" :variant="variant"></b-progress>
							</div>
							<div class="error-msg" v-if="installError">{{installError}}</div>
							<div v-if="installFinished" class="success">Successfully Installed</div>
							<div v-if="showFooter || installFinished" class="install-modal-footer">
					       		<b-btn variant="primary" size="sm" @click="reloadBaseURL()" :disabled="buttonLoaders.login">Reload App
					       		</b-btn>
							</div>
						</b-modal>
					</div>
					<b-modal modal-class="addons-page" ref="updateAddonModal" :centered="true" hide-header-close hide-footer title="Update Addons" no-fade>
						<div class="uptate-confirm">
					         Are you sure want to update all addons?
						</div>
						<div class="login-footer">
				       		<b-btn variant="flat" size="sm" @click="hideUpdateModal()">Cancel</b-btn>
				       		<b-btn variant="primary" size="sm" @click="startAddonsUpdate()">Yes</b-btn>
						</div>
				    </b-modal>
				    <b-modal modal-class="addons-page" ref="addonInstallWarningModal" hide-footer title="Login to infinitewp.com" no-fade>
				    	<div class="login-error aler-msg" v-if="loginError"><span class="error_svg"><error-icon class="icon-default"></error-icon></span><div class="error_msss" v-html="loginError"></div></div>
						<div class="login-form" v-if="loginError==false">
					        <div class="label-80">This account is connected with another panel.</div>
					        <div class="label-81">Do you want to connect this panel instead?</div>
					        <div class="label-warning">The connection with the other panel will be broken.Premium addons, if any, will be uninstalled.</div>
							
						</div>
						<div class="login-footer" v-if="loginError==false">
				       		<b-btn variant="flat" size="sm" @click="hideAddonInstallWarningModal()">No! Don't</b-btn>
				       		<b-btn variant="primary" size="sm" @click="userLogin()" :disabled="buttonLoaders.login">Yes, Connect this panel instead.
							<spinner size="small" v-if="buttonLoaders.login"></spinner>
				       		</b-btn>
						</div>
						<div class="login-footer" v-if="loginError" style="margin-top: 25px;">
				       		<b-btn variant="primary" size="sm" @click="hideAddonInstallWarningModal()">Close
				       		</b-btn>
						</div>
				    </b-modal>
				</b-col>
			</b-row>
		<!-- </b-card> -->
	</div>
</template>

<script>
import ReloadIcon from '../../assets/reload.svg';
import ErrorIcon from '../../assets/error.svg';
import InstallClone from '../../assets/installClone.svg';
import backupRepository from '../../assets/addons/backuprepository.svg';
import brokenLinks from '../../assets/addons/brokenlinks.svg';
import duoSecurity from '../../assets/addons/duosecurity.svg';
import wordFence from '../../assets/addons/wordfence.svg';
import ithemesSecurity from '../../assets/addons/ithemessecurity.svg';
import malwareScanningSucuri from '../../assets/addons/malwarescanningsucuri.svg';
import manageComments from '../../assets/addons/managecomments.svg';
import manageUsers from '../../assets/addons/manageusers.svg';
import scheduleBackup from '../../assets/addons/schedulebackup.svg';
import WPVulns from '../../assets/addons/wpvulns.svg';
import clientPluginBranding from '../../assets/addons/clientPluginBranding.svg';
import clientReporting from '../../assets/addons/clientReporting.svg';
import bulkPublish from '../../assets/addons/bulkPublish.svg';
import codeSnippets from '../../assets/addons/codeSnippets.svg';
import fileEditor from '../../assets/addons/fileEditor.svg';
import googleAnalytics from '../../assets/addons/googleAnalytics.svg';
import googlePageSpeed from '../../assets/addons/googlePageSpeed.svg';
import googleSafeBrowsing from '../../assets/addons/googleSafeBrowsing.svg';
import uptimeMonitorUptimeRobot from '../../assets/addons/uptimeMonitorUptimeRobot.svg';
import wpOptimize from '../../assets/addons/wpOptimize.svg';
import WPTC from '../../assets/addons/WPTC.svg';
import staging from '../../assets/addons/staging.svg';
import multiUser from '../../assets/addons/multiuser.svg';
import Switches from "vue-switches";
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import { EventBus } from "../../event/event-bus.js";
export default {
	components :{
		ReloadIcon,
		ErrorIcon,
		InstallClone,
		Switches,
		backupRepository,
		brokenLinks,
		wordFence,
		duoSecurity,
		ithemesSecurity,
		malwareScanningSucuri,
		manageComments,
		manageUsers,
		scheduleBackup,
		WPVulns,
		clientPluginBranding,
		codeSnippets,
		fileEditor,
		googleAnalytics,
		googlePageSpeed,
		googleSafeBrowsing,
		wpOptimize,
		WPTC,
		uptimeMonitorUptimeRobot,
		staging,
		multiUser,
		clientReporting,
		bulkPublish

	},
	data() {
		return {
			plan:{},
			login: {
				username : '',
				password : ''
			},
			loginError:false,
			modalAction:'',
			modalProcess:false,
			buttonLoaders: {
				checkUpdate:false,
				login:false,
			},
			addonModalTitle: "Installing",
			progressMsg: "Addon Installation yet to start",
			max: 100,
			value: 10,
			variant: "primary",
			installError: false,
			showFooter: false,
			startInstall: false,
			installFinished: false,
			token: '',
			singleUpdate: false,
		};
	},
	validations: {
	    login: {
	      username:{
	      	required,
	      	minLength:minLength(1)
	      },
	      password:{
	      	required,
	      	minLength:minLength(1)
	      }
	    },
	},
	mounted() {
		this.getAddonsPage();
		EventBus.$emit('hide-site-lists', true);
		EventBus.$emit('show-site-lists', true);
	},
	beforeDestroy(){
		EventBus.$emit('hide-site-lists', false);
		EventBus.$emit('show-site-lists', false);
	},
	computed: {
		appInfo() {
		  return this.$store.getters.getAppInfo;
		}
	},
	methods: {
		getAddonsPage(){
			let params = {
			  requiredData: {
			    getAddonsPageHTMLV3: 1,
			    getAddonAlertCount:1
			  }
			};
			this.$store.dispatch("sendAction", params).then(response => {
			  this.plan = response.data.getAddonsPageHTMLV3;
			  this.$store.commit('SET_ADDONS_UPDATE_INFO', response.data.getAddonAlertCount);
			});
		},
		showLoginModal(action){
			this.modalAction = action;
			this.loginError = false;
			this.login.username='';
			this.login.password='';
			this.$refs.userLogin.show();
			this.$v.$reset();
	    },
	    hideLoginModal () {
	      	this.$refs.userLogin.hide()
	    },
	    userLogin(evt){
	    	if (!this.process) {
	    		evt.preventDefault();
	    	}
	    	this.$v.$touch();
	    	if (this.$v.$invalid) {
		    	return
		    }
	    	let params = {
	    	  requiredData: {
	    	    IWPAuthUserV3: this.login
	    	  }
	    	};
	    	this.buttonLoaders.login = true;
	    	this.loginError = false;
	    	if (this.process) {
	    		params.requiredData.IWPAuthUserV3.process = this.process;
	    	}else{
	    		params.requiredData.IWPAuthUserV3.login = 'yes';
	    		params.requiredData.IWPAuthUserV3.action = this.modalAction;
	    	}
	    	this.$store.dispatch("sendAction", params).then(response => {
	    	  let result = response.data.IWPAuthUserV3;
	    	  console.log(result);
	    	  this.buttonLoaders.login = false;
	    	  if (result.error) {
	    	  	this.loginError = result.message;
	    	  }else if (result.warning) {
	    	  	this.showAddonInstallWarningModal()
	    	  }else if(result.success){
	    	  	if (this.modalAction == 'installAddons') {
	    	  		this.token = result.token;
	    	  		this.showAddonInstallAndUpdateModal(result.token);
	    	  	}else{
		    	  	this.hideLoginModal();
		    	  	this.hideAddonInstallWarningModal();
		    	  	this.checkUpdate();
	    	  	}
	    	  }

	    	});
	    },
	    checkUpdate() {
	      this.buttonLoaders.checkUpdate = true;
	      let payload = {
	        requiredData: {
	          forceCheckUpdateV3: 1,
	          getAddonsPageHTMLV3: 1,
	          getAddonAlertCount:1
	        }
	      };
	      this.$store.dispatch('sendAction', payload).then(response => {
	      	if (response.data.forceCheckUpdateV3.error) {
	      		window.eventHub.$emit('sendNotification', {
	      		  notifications: [{
	      		  	group: 'foo',
	      		  	title: 'Connection error',
	      		  	type: 'E',
	      		  	message: response.data.forceCheckUpdateV3.errorMsg,
	      		  	delay:-1
	      		  }
	      		  ]
	      		});
	      	}else{
		        let update = response.data.forceCheckUpdateV3;
		        this.$store.commit('SET_PANEL_UPDATE_INFO', update);
		        this.$store.commit('SET_ADDONS_UPDATE_INFO', response.data.getAddonAlertCount);
	      	}
	        this.buttonLoaders.checkUpdate = false;
	        this.plan = response.data.getAddonsPageHTMLV3;
	      });
	    },
	    activeORdeactivae(slug, currentStatus){
	    	if (currentStatus == 'active') {
		    	var params = {
		    	  requiredData: {
		    	    deactivateAddonsV3: {}
		    	  }
		    	};
		    	params.requiredData.deactivateAddonsV3.addons ={};
		    	params.requiredData.deactivateAddonsV3.addons.key ={};
		    	params.requiredData.deactivateAddonsV3.addons.key.slug = slug;
	    	}else if (currentStatus == 'inactive') {
		    	var params = {
		    	  requiredData: {
		    	    activateAddonsV3: {}
		    	  }
		    	};
		    	params.requiredData.activateAddonsV3.addons ={};
		    	params.requiredData.activateAddonsV3.addons.key ={};
		    	params.requiredData.activateAddonsV3.addons.key.slug = slug;
	    	}
				this.$store.dispatch("sendAction", params).then(response => {
				   	this.reload()
				});
	    },
    	showAddonInstallAndUpdateModal(token){
    		let params = {
    		  requiredData: {
    		    getNewAddonAvailableV3: 1
    		  }
    		};
    		this.$store.dispatch("sendAction", params).then(response => {
    			if (response.data.getNewAddonAvailableV3) {
    				this.$refs.addonInstallAndUpdateModel.show();
					this.processAddonsInstallation(response.data.getNewAddonAvailableV3, token);
    			}
    		});

        },
        triggerNextAddonInstall(){
    		let params = {
    		  requiredData: {
    		    getNewAddonAvailableV3: 1
    		  }
    		};
    		this.$store.dispatch("sendAction", params).then(response => {
    			if (response.data.getNewAddonAvailableV3) {
					this.processAddonsInstallation(response.data.getNewAddonAvailableV3, this.token);
    			}else{
					this.value = 100;
					this.installFinished = true;
	    			this.showFooter = true;
    			}
    		});

        },
        hideAddonInstallAndUpdateModal () {
          	this.$refs.addonInstallAndUpdateModel.hide()
        },
        reload(){
        	location.reload(true)
        },
        reloadBaseURL(){
        	let payload = {
        	  requiredData: {
        	    forceCheckUpdateV3: 1,
        	  }
        	};
        	this.$store.dispatch('sendAction', payload).then(response => {
        		this.reload();
        	});
        },
        processAddonsInstallation(addons, token){
        	// _.forEach(addons, (value, key)=>{
        		let addon = {};
        		addons.token = token;
        		addon[addons.slug] = addons;
        		this.progressMsg  = "Checking download for "+addons.slug;
        		this.value = 0;
        		let downloadResponse = this.getAddonDownloadURL(addon, addons.slug, 'install');
        		if (this.installError) {
        			return;
        		}

        	// })
        	// if (this.installError == false) {
        	// 	this.installFinished = true;
        	// 	this.showFooter = true;
        	// }
        },
        getAddonDownloadURL(addon, key, mode){
        	let params = {
    		  requiredData: {
    		    getAddonsDownloadURL: addon
    		  }
    		};
    		console.log(addon);
    		this.$store.dispatch("sendAction", params).then(response => {
    			let result = response.data.getAddonsDownloadURL;
    			console.log(result[key]);
    			this.value = 30;
    			if (result[key].downloadLink) {
					this.progressMsg = 'Downloading '+key+' package';
					this.downloadAddon(result, key, mode);
    			}else if (result[key].error){
    				this.showFooter = true;
    				this.installError = result[key].errorMsg;
    			}
    		});
        },
        downloadAddon(addon, key, mode){
        	let params = {
    		  requiredData: {
    		    downloadAddons: addon
    		  }
    		};
    		this.$store.dispatch("sendAction", params).then(response => {
    			let result = response.data.downloadAddons;
    			console.log(result[key]);
    			this.value = 40;
    			if (result[key].zip) {
					this.progressMsg = 'Unzipping '+key+' package';
					this.unzipAddon(result, key, mode);
    			}else if (result[key].error){
    				this.showFooter = true;
    				this.installError = result[key].errorMsg;
    			}
    		});
        },
        unzipAddon(addon, key, mode){
        	let params = {
    		  requiredData: {
    		    unZipAddons: addon
    		  }
    		};
    		this.$store.dispatch("sendAction", params).then(response => {
    			let result = response.data.unZipAddons;
    			console.log(result[key]);
    			this.variant= 'success';
    			if (result[key].error){
    				this.showFooter = true;
    				this.installError = result[key].errorMsg;
    			}else if (result[key].process.unzipDone) {
    				this.value = 50;
    				if (mode == 'install') {
						this.progressMsg = 'Installing '+key+' package';
    					this.installAddon(result, key);
    				}else{
    					this.progressMsg = 'Updating '+key+' package';
    					this.updateAddon(result, key);
    				}
    			}
    		});
        },
        installAddon(addon, key){
        	let params = {
    		  requiredData: {
    		    installAddons: addon
    		  }
    		};
    		this.value = 75;
    		this.$store.dispatch("sendAction", params).then(response => {
    			let result = response.data.installAddons;
    			console.log(result[key]);
    			this.variant= 'success';
    			if (result[key].installed) {
    				this.value = 99;
					this.triggerNextAddonInstall();
    			}else if (result[key].error){
    				this.showFooter = true;
    				this.installError = result[key].errorMsg;
    			}
    		});
        },
        updateAddon(addon, key){
        	let params = {
    		  requiredData: {
    		    updateAddons: addon
    		  }
    		};
    		this.value = 75;
    		this.$store.dispatch("sendAction", params).then(response => {
    			let result = response.data.updateAddons;
    			console.log(result[key]);
    			this.variant= 'success';
    			if (result[key].installed) {
					// this.progressMsg = 'Installing '+key+' package';
    				this.value = 99;
    				this.triggerNextAddonUpdate();
    			}else if (result[key].error){
    				this.showFooter = true;
    				this.installError = result[key].errorMsg;
    			}
    		});
        },
        showUpdateModal(action){
			this.$refs.updateAddonModal.show()
	    },
	    hideUpdateModal () {
	      	this.$refs.updateAddonModal.hide()
	    },
	    startAddonsUpdate(){
	    	this.addonModalTitle = "Updating"
	    	let params = {
    		  requiredData: {
    		    getUpdateAvailableAddonV3: 1
    		  }
    		};
    		this.$store.dispatch("sendAction", params).then(response => {
    			if (response.data.getUpdateAvailableAddonV3) {
    				this.$refs.addonInstallAndUpdateModel.show();
					this.processAddonsUpdation(response.data.getUpdateAvailableAddonV3);
    			}
    		});
	    },
	    processAddonsUpdation(addons){
        	// _.forEach(addons, (value, key)=>{
        		let addon = {};
        		addon[addons.slug] = addons;
        		this.progressMsg  = "Checking download for "+addons.slug;
        		this.value = 0;
        		let downloadResponse = this.getUpdateAddonDownloadURL(addon, addons.slug, 'update');
        		if (this.installError) {
        			return;
        		}

        	// })
        	// if (this.installError == false) {
        	// 	this.installFinished = true;
        	// 	this.showFooter = true;
        	// }
        },
        triggerNextAddonUpdate(){
        	if (this.singleUpdate) {
        		this.value = 100;
				this.installFinished = true;
    			this.showFooter = true;
    			return;
        	}
    		let params = {
    		  requiredData: {
    		    getUpdateAvailableAddonV3: 1
    		  }
    		};
    		this.$store.dispatch("sendAction", params).then(response => {
    			if (response.data.getUpdateAvailableAddonV3) {
					this.processAddonsUpdation(response.data.getUpdateAvailableAddonV3);
    			}else{
					this.value = 100;
					this.installFinished = true;
	    			this.showFooter = true;
    			}
    		});

        },
        getUpdateAddonDownloadURL(addon, key){
        	let params = {
    		  requiredData: {
    		    getUpdateAddonsDownloadURL: addon
    		  }
    		};
    		this.$store.dispatch("sendAction", params).then(response => {
    			let result = response.data.getUpdateAddonsDownloadURL;
    			console.log(result[key]);
    			this.value = 30;
    			if (result[key].downloadLink) {
					this.progressMsg = 'Downloading '+key+' package';
					this.downloadAddon(result, key);
    			}else if (result[key].error){
    				this.showFooter = true;
    				this.installError = result[key].errorMsg;
    			}
    		});
        },
        singleAddonUpdate(slug){
        	console.log(slug);
        	// return false;
        	this.addonModalTitle = "Updating"
	    	let params = {
    		  requiredData: {
    		    getUpdateAvailableAddonsV3: 1
    		  }
    		};
    		this.singleUpdate = true;
    		this.$store.dispatch("sendAction", params).then(response => {
    			if (response.data.getUpdateAvailableAddonsV3) {
    				let addon = {};
    				addon[slug] = response.data.getUpdateAvailableAddonsV3[slug];
    				this.$refs.addonInstallAndUpdateModel.show();
    				console.log(addon[slug])
					this.processAddonsUpdation(addon[slug]);
    			}
    		});
        },
        showAddonInstallWarningModal(action){
        	this.process = 'changeRegister';
			this.$refs.addonInstallWarningModal.show()
	    },
	    hideAddonInstallWarningModal () {
	      	this.$refs.addonInstallWarningModal.hide()
	    },

	}
};
</script>

<style scoped lang= "scss">
@import "../../sass/_mixins";
@import "../../sass/_variables";
$font-color:#444444;
$border-color:rgba(149, 152, 154, 0.34);
	.addons-page{
		background-color: #FFFFFF;
		padding: 30px 30px 30px 70px;
		min-height: 100%;
		.account-label{
			@include Text-Style-41;
			float: left;
		}
		.register-user{
			@include Text-Style-5;
			margin-left: 5px;
			float: left;
		}
		.plan-details{
			margin-top: 42px;
			margin-left: 15px;
			.left-label{
				color: $font-color;
				@include Text-Style-44;
				padding-top: 8px;
				font-weight: 400;
			}
			.right-label{
				color: $font-color;
				@include Text-Style-73;
				padding-top: 8px;
				text-transform: capitalize;
				margin-left: -126px;
			}
			.expired{
				color: $tomato;
				padding-left: 5px;
			}
			.icon-expire{
				width: 10px;
			}
		}
		.install-addons-header{
			background-color: #f1f2f2;
			border: 1px solid $border-color;
			padding: 20px 0px 18px 19px;
			@include Text-Style-29;
			border-radius: 5px 5px 0px 0px;
			color: rgba(68, 68, 68, 0.87);
			button{
				float: right;
				margin: -10px 13px;
			}
		}
		.install-addons-content{
			border: 1px solid $border-color;
			border-top: none;
			border-bottom: none;
			background-color: rgba(251, 251, 251, 1);
			padding: 7px;
			color: rgba(68, 68, 68, 0.87);
			@include Text-Style-73;
		}
		.install-addons-list{
			border: 1px solid $border-color;
			border-top: none;
			border-bottom: none;
			padding: 7px;
			color: rgba(68, 68, 68, 0.87);
			@include Text-Style-33;
			.opacity{
				opacity: 0.54;
			}
			.version{
				cursor: pointer;
				color: rgba(35, 134, 219, 0.87);
			}
		}
		
		.addon-table{
			border-bottom: 1px solid rgba(149, 152, 154, 0.34);
			position: relative;
			td{
				padding: 7px;
			}
		}

		.update-addon{
			/* td{ */
				padding: 11px !important;
			/* } */
		}

		.addon-empty{
			border: 1px solid $border-color;
			border-top: none;
			padding: 7px;
			color: rgba(68, 68, 68, 0.87);
			border-radius: 0px 0px 5px 5px;
			@include Text-Style-33;
		}
		.checknow{
			width: 13px;
			height: 13px;
			margin-right: 8px;
			margin-top: 3px;
		}
		.active-bar{
			border: 1.5px solid rgba(174, 180, 186, 0.54);
			/* padding: 0px 30px 1px 30px; */
			background: rgba(232, 232, 232, 0.54);
			border-radius: 10px;
			width: 31px;
			height: 13px;
		}
		.active{
			width: 16px;
			height: 16px;
			background: rgba(35, 134, 219, 1);
			border-radius: 50%;
			position: absolute;
    		margin: -15px;
    		cursor: pointer;
    		right: 103px;
    		border: 1.5px solid rgba(255, 255, 255, 1);

		}
		.deactive {
		    width: 16px;
		    height: 16px;
		    background: rgba(220, 220, 220, 1);
		    border-radius: 50%;
		    position: absolute;
		   	margin: -14px;
		   	right: 117px;
		    cursor: pointer;
		    border: 1.5px solid white;
		}
		.acitve-plan {
				    color: #20B497 !important;
				    text-transform: uppercase !important;
		}
		.expired{
			color: rgba(255, 67, 0, 0.87);
		}
		.renew-link{
			/* position: absolute; */
			margin-right: 22px;
			bottom: 9px;
			float: right;
		}
		.login-form{
			padding: 34px 58px 34px 66px;
			label{
				@include Text-Style-85;
			}
		}
		.login-footer{
			padding: 17px 24px 17px 0px;
			background-color: $white-three;
			text-align: right;
			border-radius: 8px;
		}
		.login-error{
			margin: 26px 24px 0px 24px;
			padding: 13px;
			border-radius:  3px;
		}
		.error_msss{
			margin-left: 30px;
		}
		.error_svg{
			position: absolute;
		}
		.addons-icon{
			width: 16px;
			height: 16px;
			margin-right: 7px;
			margin-top: -2px;
		}
		.uptate-confirm{
			text-align: center;
			padding:  20px 0px 20px 0px;
		}
		&.install-modal{
			.model-title{
				@include Text-Style-81;
				color: $greyish-brown;
				opacity: 0.87;
				margin-top: 41px;
			}
			.progress-msg{
				@include Lato-Semibold;
				color: $greyish-brown;
				opacity: 0.64;
			}
			.install-progress{
			    width: 188px;
			    margin: 21px 0px 52px 152px;
			    .progress {
			      background-color: rgba($greyish-brown-54, 0.14);
			      .progress-bar {
			        background-color: $dark-sky-blue;
			      }
			    }
			}
			.error-msg{
				@include Lato-Semibold;
				color: $coral;
				margin-bottom: 42px;
				overflow: hidden;
			    white-space: nowrap;
			    text-overflow: ellipsis;
			}
			.install-modal-footer{
				padding: 17px 24px 17px 0px;
				background-color: $white-six-30;
				text-align: right;
			}
			.success{
				@include Lato-Semibold;
				color: $true-green;
				background-color: rgba(213, 235, 213, 0.54);
				width: 141px;
				margin: 23px 0px 42px 179px;
				border: 1px solid rgba(6, 159, 20, 0.54);
				border-radius:  3px;
			}
		}
		.label-80{
			@include Text-Style-80;
			color: $greyish-brown-87;
		}
		.label-81{
			@include Text-Style-81;
			color: $greyish-brown-87;
			margin-top: 9px;
		}
		.label-warning{
			@include Text-Style-78;
			margin-top: 29px;
			border: 1px solid $yellow-orange-64;
			border-radius: 5px;
			background-color: $off-white-96;
			padding: 7px 28px 7px 28px;
		}
	}
</style>